module.exports = __webpack_public_path__ + "static/Internet of Things-5db55dedda89fa63687e805aaa9f6ca2.svg";